<template>
  <div>
    <div class="weui-mask" :class="sheet ? 'mask_act':'mask_nor'" id="iosMask" @click="cancel_sheet"></div>
    <div class="weui-actionsheet" :class="sheet ? 'weui-actionsheet_toggle':''" id="iosActionsheet">
      <div class="weui-actionsheet__title">
        <p class="weui-actionsheet__title-text">{{ sheetTitle }}</p>
      </div>
      <div class="weui-actionsheet__menu">
        <template v-for="item,index in sheetLs">
          <div class="weui-actionsheet__cell" @click="sel_sheet(index)">{{ item.name }}</div>
        </template>
      </div>
      <div class="weui-actionsheet__action">
        <div class="weui-actionsheet__cell" id="iosActionsheetCancel" @click="cancel_sheet">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'actionSheet',
    props:['sheet','sheetTitle','sheetLs'],
    methods:{
      // 选择
      sel_sheet(index){
        var that = this;
        that.$emit('sel_sheet',index);
      },
      // 取消
      cancel_sheet(){
        var that = this;
        that.$emit('cancel_sheet',false,'','');
      }
    }
  }
</script>

<style>
  .mask_nor{
    display: none;
    opacity: 0;
  }
  .mask_act{
    display: block;
    animation: mask .3s linear forwards;
  }
  @keyframes mask {
    0%{ opacity: 0}
    100%{ opacity: 1}
  }
</style>



// WEBPACK FOOTER //
// src/components/actionSheet.vue